import { render } from "./BoxCard.vue?vue&type=template&id=46cbade7&scoped=true"
import script from "./BoxCard.vue?vue&type=script&lang=ts"
export * from "./BoxCard.vue?vue&type=script&lang=ts"

import "./BoxCard.vue?vue&type=style&index=0&id=46cbade7&lang=scss"
import "./BoxCard.vue?vue&type=style&index=1&id=46cbade7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46cbade7"

export default script